<user-ingot-base [user]="user" [link]="user | k2UserLink">
  <div class="d-flex flex-column">
    @if (numberOfActiveAssignments === 1) {
    <span>1 active assignment</span>
    } @if (numberOfActiveAssignments !== 1) {
    <span> {{ numberOfActiveAssignments }} active assignments </span>
    } @if (numberOfOngoingAssignments === 1) {
    <span>1 ongoing assignment</span>
    } @if (numberOfOngoingAssignments !== 1) {
    <span> {{ numberOfOngoingAssignments }} ongoing assignments </span>
    }
  </div>
</user-ingot-base>
